import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AnyAction, Store } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { AuthState } from "./store";

export const useAuthDispatch = () =>
  useDispatch<ThunkDispatch<AuthState | Store, null, AnyAction>>();
export const useAuthSelector: TypedUseSelectorHook<AuthState> = useSelector;
